import { merge } from 'lodash';
import getBackground from 'nucleus-widgets/utils/style/getBackground';
import clearImageInTheme from './clearImageInTheme';
import { createSelector } from 'reselect';

/**
* Workaround to get the inline style to apply to the dialog container.
*/
export default function getDialogContainerStyle(state) {
  const { global, sections } = state.website.theme;
  const style = {
    ...clearImageInTheme(merge({}, global, sections.content1)),
    styleMapping: 'custom'
  };
  return getBackground(style, style.customSettings, style.palette);
}

export const getMemoizeDialogContainerStyle = createSelector(
  state => state.website.theme.global,
  state => state.website.theme.sections,
  (global, sections) => {
    const style = {
      ...clearImageInTheme(merge({}, global, sections.content1)),
      styleMapping: 'custom'
    };
    return getBackground(style, style.customSettings, style.palette);
  }
);
